import type { FC } from 'react'
import styled from '@emotion/styled'

import Image from '@segment/matcha/components/Image'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import PersonalizedCustomerEngagementPng2x from './assets/PersonalizedCustomerEngagement@2x.png'
import PersonalizedCustomerEngagementWebp from './assets/PersonalizedCustomerEngagement.webp'
import PersonalizedCustomerEngagementWebp2x from './assets/PersonalizedCustomerEngagement@2x.webp'

const copy = {
  heading: `Build personalized customer engagement without sacrificing data privacy`,
  description: `By utilizing Retrieval Augmented Generation (RAG), the CustomerAI Personalization Engine listens to the customer query and— based on the natural language message—only extracts the most relevant customer data from Segment to ingest into the LLM for conversational intelligence.`,
}

const PersonalizedCustomerEngagement: FC = () => {
  return (
    <SectionBase variant="2Col" reverse={true}>
      <SectionCopy>
        <CopyTextBase>
          <CopyText.Heading variant="h2">{copy.heading}</CopyText.Heading>
          <CopyText.Description variant="pLarge" tag="p">
            {copy.description}
          </CopyText.Description>
        </CopyTextBase>
      </SectionCopy>

      <Section.Contents>
        <picture>
          <source
            type="image/webp"
            srcSet={`${PersonalizedCustomerEngagementWebp}, ${PersonalizedCustomerEngagementWebp2x} 2x`}
          />
          <Image
            src={PersonalizedCustomerEngagementPng2x}
            alt="Illustration: Build personalized customer engagement"
            width="580"
            height="450"
            loading="lazy"
          />
        </picture>
      </Section.Contents>
    </SectionBase>
  )
}

const SectionCopy = styled(Section.Copy)`
  display: flex;
  align-items: center;

  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 440px;
    justify-self: end;
    align-self: center;
  }
`

export default PersonalizedCustomerEngagement
